import { useEffect, useRef } from "react";

/* The cursor becomes the URWAN zipper pull — it swings gently over clickable elements. */
export default function RivetCursor() {
    const ref = useRef(null);

    useEffect(() => {
        if (
            !window.matchMedia("(pointer: fine)").matches ||
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
            return;
        }
        document.documentElement.classList.add("rivet-cursor");
        const el = ref.current;
        let tx = window.innerWidth / 2;
        let ty = window.innerHeight / 2;
        let x = tx;
        let y = ty;
        let hot = false;
        let down = false;
        let raf;

        const onMove = (e) => {
            tx = e.clientX;
            ty = e.clientY;
        };
        const onOver = (e) => {
            hot = Boolean(
                e.target.closest && e.target.closest("a, button, input, select, textarea, label"),
            );
        };
        const onDown = () => {
            down = true;
        };
        const onUp = () => {
            down = false;
        };
        const loop = () => {
            x += (tx - x) * 0.3;
            y += (ty - y) * 0.3;
            const scale = down ? 0.82 : hot ? 1.3 : 1;
            const rot = hot ? Math.sin(performance.now() / 260) * 16 : 0;
            el.style.transform = `translate3d(${x - 24}px, ${y - 6}px, 0) rotate(${rot}deg) scale(${scale})`;
            el.style.opacity = "1";
            raf = requestAnimationFrame(loop);
        };
        window.addEventListener("pointermove", onMove, { passive: true });
        window.addEventListener("mouseover", onOver, { passive: true });
        window.addEventListener("pointerdown", onDown);
        window.addEventListener("pointerup", onUp);
        raf = requestAnimationFrame(loop);

        return () => {
            cancelAnimationFrame(raf);
            document.documentElement.classList.remove("rivet-cursor");
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("mouseover", onOver);
            window.removeEventListener("pointerdown", onDown);
            window.removeEventListener("pointerup", onUp);
        };
    }, []);

    return (
        <div
            ref={ref}
            data-testid="zipper-cursor"
            aria-hidden="true"
            className="pointer-events-none fixed left-0 top-0 z-[120] opacity-0 will-change-transform"
        >
            <img
                src="/img/denim/zipper-cursor.png"
                alt=""
                draggable="false"
                className="h-11 w-auto select-none drop-shadow-[0_5px_12px_rgba(0,0,0,0.65)]"
            />
        </div>
    );
}
